<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      d="M12.25 22.75H7.87501C7.00653 22.7489 6.14821 22.5632 5.35699 22.2051C4.56578 21.847 3.85977 21.3247 3.2858 20.6729C2.71184 20.0211 2.28305 19.2547 2.02789 18.4245C1.77273 17.5944 1.69702 16.7195 1.8058 15.8578C1.91458 14.9962 2.20536 14.1675 2.65884 13.4268C3.11231 12.6861 3.71812 12.0504 4.43607 11.5617C5.15401 11.073 5.96767 10.7426 6.82306 10.5923C7.67846 10.4421 8.55601 10.4755 9.39751 10.6903"
      stroke="#797979"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.125 17.5L16.625 14L20.125 17.5"
      stroke="#797979"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.625 22.75V14"
      stroke="#797979"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.75 13.9999C8.75037 12.4224 9.17717 10.8744 9.98524 9.51968C10.7933 8.16492 11.9526 7.0538 13.3404 6.3039C14.7282 5.554 16.2929 5.19322 17.8689 5.25974C19.445 5.32625 20.9737 5.81758 22.2934 6.68174C23.6131 7.5459 24.6747 8.75074 25.3657 10.1688C26.0567 11.5868 26.3516 13.1653 26.2191 14.7371C26.0865 16.309 25.5315 17.8158 24.6128 19.0981C23.694 20.3804 22.4458 21.3905 21 22.0215"
      stroke="#797979"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "UploadDropIcon",
};
</script>
